import React, { Component } from 'react';
import { Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { attachCloudinaryOptionsToImageSource, IMAGE_PROPS } from '../../utils/ImageUtils';
import { DEFAULT_IMAGE_URLS } from '../../Constants';
import Image from '../../components/Image';
import VerbHeading from '../../components/VerbHeading';
import VerbButton, { VERB_BUTTON_TYPE, FONT_AWESOME_ICON_WEIGHT } from '../../components/VerbButton';

export default class CollectionSubscriptionBanner extends Component {
    static propTypes = {
        collection: PropTypes.object,
        createUserCollection: PropTypes.func,
        history: PropTypes.object
    };

    constructor(props) {
        super(props);
        this.state = {
            buttonDisabled: false
        };
    }

    _handleSubscribeOnclick = () => {
        const { createUserCollection, history } = this.props;
        this.setState({ buttonDisabled: true });
        return createUserCollection().then((createdCollection) => {
            if (createdCollection.content) {
                for (let i = 0; i < createdCollection.content.length; i += 1) {
                    const asset = createdCollection.content[i];
                    if (!asset.isCompleted) {
                        return history.push(`/workspace/${asset.userLearningAssetId}`, {
                            userCollection: {
                                id: createdCollection._id,
                                started: true
                            }
                        });
                    }
                }
            }
            return history.push(`/collection/${createdCollection.collectionId}`, { showBanner: true });
        });
    };

    render() {
        const { collection = {} } = this.props;
        const { buttonDisabled } = this.state;
        const imageProps = IMAGE_PROPS.collectionImageCloudinary;
        const coverImageUrl = collection.coverImageUrl || DEFAULT_IMAGE_URLS.COLLECTION_BANNER_COVER_IMAGE;
        const backgroundUrl = attachCloudinaryOptionsToImageSource(coverImageUrl, {
            color: '000000',
            colorize: 40
        });
        const backgroundStyle = {
            backgroundImage: `url(${backgroundUrl})`,
            backgroundPosition: 'center 10%',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat'
        };

        return (
            <div className={'collection-subscription-banner'} style={backgroundStyle}>
                <div className={'container'}>
                    <Row className={'collection-infos'}>
                        <div className={'collection-thumbnail-container col-md-3 col-sm-12 col-12'}>
                            <Image
                                src={collection.thumbnailImageUrl || ''}
                                dimension={imageProps.dimension}
                                cloudinaryCrop={imageProps.cloudinaryCrop}
                                className={'collection-thumbnail'}
                                quality={{ q: 100 }}
                            />
                        </div>
                        <div className={'collection-details col-md-9 col-sm-12 col-12'}>
                            <VerbHeading hNumber={6} messageId={'HEADING_COLLECTION'} defaultMessage={'COLLECTION'} />
                            <h1 className={'collection-name'}>{collection.name || ''}</h1>
                            <div className={'collection-subtitle-container'}>
                                <span className={'collection-subtitle'}>{collection.subtitle}</span>
                            </div>
                            <div className={'col-12 col-sm-6'}>
                                <VerbButton
                                    textId={'BUTTON_BEGIN'}
                                    defaultMessage={'BEGIN'}
                                    disabled={buttonDisabled}
                                    onClick={this._handleSubscribeOnclick}
                                />
                            </div>
                            {collection.resources && collection.resources.length ? (
                                <div className={'col-12 col-sm-6'}>
                                    <VerbButton
                                        textId={'REFERENCES_COLLECTION_HEADING'}
                                        defaultMessage={'REFERENCES'}
                                        className={'verb-button-locked'}
                                        buttonType={VERB_BUTTON_TYPE.PRIMARY_DEFAULT}
                                        fontAwesomeIcon={'fa-lock-alt'}
                                        disabled={true}
                                        fontAwesomeIconWeight={FONT_AWESOME_ICON_WEIGHT.SOLID}
                                    />
                                </div>
                            ) : null}
                        </div>
                    </Row>
                </div>
            </div>
        );
    }
}
